export const PRODUCTS = {
    BETTER_ENERGY: "BETTER_ENERGY",
};

export const PRODUCT_MODULES = {
    BETTER_CONTROL: "BETTER_CONTROL",
    BETTER_MONITOR: "BETTER_MONITOR",
};

export const FEATURES = {
    PREHEATING_EARLYCHECKOUT: "PREHEATING_EARLYCHECKOUT",
};
